import React, { FC } from 'react';
import SVGUniqueID from 'react-svg-unique-id';

import { SVGComponentProps } from '../type';

const SampleReportIcon: FC<SVGComponentProps> = ({
  width = 16,
  height = 16,
  stroke = '#1e293b',
  fill = '#000'
}) => {
  return (
    <SVGUniqueID>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          opacity={0.12}
          d="M12.748 4.748 9.92 1.92a2 2 0 0 0-.586-.406v2.753c0 .374 0 .56.073.703a.67.67 0 0 0 .291.291c.143.073.33.073.703.073h2.753a2 2 0 0 0-.406-.586"
          fill={fill}
        />
        <path
          d="M9.333 1.514v2.753c0 .374 0 .56.072.703a.67.67 0 0 0 .292.291c.142.073.329.073.702.073h2.754m-3.82 6h-4m5.333-2.667H5.333m8-2.008v4.808c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874c-.428.218-.988.218-2.108.218H5.866c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874c-.218-.427-.218-.988-.218-2.108V4.534c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874c.428-.218.988-.218 2.108-.218h2.141c.49 0 .734 0 .964.055a2 2 0 0 1 .578.24c.202.123.375.296.72.642l2.126 2.126c.346.346.52.519.643.72q.165.27.24.579c.055.23.055.474.055.963"
          stroke={stroke}
          strokeWidth={1.667}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SVGUniqueID>
  );
};

export { SampleReportIcon };
